import { Component, computed, effect, inject, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { TypeActivite } from '../../../../models/v2/ot.model';
import { DemarrerOtService } from '../../../../../mnt/ot/demarrer-ot.service';
import { UserGeolocConsentService } from '../../../../providers/auth/user-geoloc-consent.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { ChronoActiviteService } from '../../../../providers/chrono-activite/chrono-activite.service';
import { ActiviteEnCoursService } from '../../../../components/activite-en-cours/activite-en-cours.service';
import { BehaviorSubject } from 'rxjs';

export type DailyOtCardItem = {
  site: string;
  type: TypeActivite;
  startTime: string;
  endTime: string;
  idOt: string;
  idSite: string;
  est_rdv_client?: boolean;
  has_echapetbelle?: boolean;
  numeroOt: string;
  libelleOt: string;
  est_controle_reglementaire?: boolean;
  presence_document: boolean;
};

@Component({
  selector: 'daily-ot-card',
  templateUrl: 'daily-ot-card.component.html',
  styleUrls: ['daily-ot-card.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule],
})
export class DailyOtCardComponent implements OnInit {
  @Input() otCardItem: DailyOtCardItem;
  public type: string;

  private readonly chronoActiviteService: ChronoActiviteService = inject(ChronoActiviteService);
  private readonly activiteEnCoursService: ActiviteEnCoursService = inject(ActiviteEnCoursService);
  private readonly router = inject(Router);
  private readonly otService = inject(DemarrerOtService);
  private readonly userGeolocConsentService = inject(UserGeolocConsentService);

  constructor() {
    effect(async () => {
      let activiteEnPauseExists: boolean = false;
      if (this.hasActiviteEncours() === false) {
        activiteEnPauseExists = await this.activiteEnCoursService.getActiviteEnPauseExists(this.otCardItem.idOt);
      }
      this.hasActiviteEnPause$.next(activiteEnPauseExists);
    });
  }

  ngOnInit(): void {
    this.type = this.otCardItem?.type;
  }

  async startOt() {
    await this.otService.startOrRestartOt(this.otCardItem?.idOt);
  }

  hasGeolocConsent() {
    return this.userGeolocConsentService.getCurrentConsentChrono();
  }

  private readonly chronoEnCours = toSignal(this.chronoActiviteService.chronoActiviteEnCours$);
  private readonly activiteEncours = toSignal(this.activiteEnCoursService.activiteEnCours$);

  readonly hasActiviteEncours = computed(() => {
    return this.activiteEncours() !== null && this.activiteEncours().id === this.otCardItem.idOt;
  });
  hasActiviteEnPause$ = new BehaviorSubject<boolean>(false);

  readonly etatActivite = computed(() => {
    if (
      this.activiteEncours().id === this.otCardItem.idOt &&
      this.chronoEnCours() &&
      this.chronoEnCours().idActivite === this.otCardItem.idOt
    ) {
      return this.chronoEnCours().horodatageEncours.statutActivite;
    }
    return undefined;
  });

  async goToOt() {
    await this.router.navigate(['/mnt/ots/', this.otCardItem?.idOt], {
      queryParams: {
        siteId: this.otCardItem?.idSite,
      },
    });
  }
}
